import React, { useContext, VFC } from 'react';

import { Button, Text } from 'mintel-react-ui';

import { AssetContainerJson } from '/types';
import { Asset, assetUri } from '/utils/assetUri';
import { PresentModeContext, PublishStatusContext } from '/utils/contexts';

import styles from './AssetColumn.scss';
import PanelColumn from './PanelColumn';
import Icon from '../Icon';

const AssetColumn: VFC<
  Pick<AssetContainerJson, 'background' | 'elements' | 'onClick'>
> = ({ background, elements }) => {
  const publishStatus = useContext(PublishStatusContext);
  const presentMode = useContext(PresentModeContext);
  const [iconName] = elements.asset.icon.split('-');
  return (
    <PanelColumn background={background} panelOnImage>
      <div className={styles.asset}>
        <Icon name={iconName} />
        <div className={styles.filename}>
          <Text.Body>{elements.asset.name}</Text.Body>
        </div>
        {!presentMode && (
          <div className={styles.download}>
            <a
              href={assetUri(
                elements.asset.asset,
                Asset.Attachment,
                publishStatus,
              )}
            >
              <Button.DownloadButton />
            </a>
          </div>
        )}
      </div>
    </PanelColumn>
  );
};

export default AssetColumn;
